<template>
  <div>
    <div class="card-box" v-if="isNumber !=2">
      <div class="card-head" :style="{background: isBackground }">
        <div class="left-icon">
          <img :src="icon" />
        </div>
        <div class="right-title">{{ title }}</div>
      </div>

      <div class="card-body" v-if="isNumber==0">
        <span class="left-content"> 余额： </span>
        <span class="right-content"> {{ money }}元 </span>
      </div>


      <div class="body-card" v-if="isNumber == 1">
        <div class="num-card">
          挂单数量:
          <span class="num">{{num}}单</span>
        </div>
        <div class="time">最早挂单时间:{{lastTime}}</div>
      </div>

    </div>


    <div class="card-box" v-if="isNumber ==2" @click="$router.push({path:`/redPackage/redPackageAudit/audit_details?code=${code}&startDeclareTime=${startDeclareTime}&endDeclareTime=${endDeclareTime}`})">
      <div class="card-head" :style="{background: isBackground }">
        <div class="left-icon">
          <img :src="icon" />
        </div>
        <div class="right-title">{{ title }}</div>
      </div>

      <div class="body-card">
        <div class="num-card">
          待审数量：
          <span class="num">{{num}}单</span>
        </div>
        <div class="time">最早转交时间:{{lastTime}}</div>
      </div>

    </div>
  </div>
</template>


<script>
import { backgroundColor } from 'echarts/lib/theme/dark';
import { string } from 'xlsx/jszip';

export default {
  props: {
    title: {
      type: String,
    },
    money: {
      type: [String, Number],
    },
    iconType: {
      type: Number,
      default: 1,
    },
    headColor: {
      type: String,
      default: "white",
    },
    isNumber: {
      type: String,
      default: false,
    },
    lastTime:{
        type:String
    },
    num:{
        type:[String,Number]
    },
    code:{
        type:String,
    },
    startDeclareTime:{
      type: String,
    },
    endDeclareTime:{
      type: String,
    }
  },
  computed: {
    icon() {
      return this.iconType == 1
        ? this.supplier1
        :this.iconType == 4
        ? this.supplier4
        : this.iconType == 2
        ? this.supplier2
        : this.supplier3;
    },
  },
  data() {
    return {
      isBackground: 'hsla(32, 94%, 93%, 0.35)',
      supplier1: require("@/assets/supplier1.png"),
      supplier2: require("@/assets/supplier2.png"),
      supplier3: require("@/assets/supplier3.png"),
      supplier4: require("@/assets/supplier4.png"),
    };
  },
  created() {
    console.log(this.isNumber)
    if(this.isNumber == 0){
      this.isBackground ="hsla(32, 94%, 93%, 0.35)" 
    }
    if(this.isNumber == 1){
      this.isBackground ="#FFF7FA" 
    }
    if(this.isNumber == 2){
      this.isBackground ="#FFF3F3" 
    }
  },
};
</script>

<style scoped lang="scss">
.card-box {
  width: 100%;
  min-height: 102px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  .card-head {
    height: 42px;
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
    // background: hsla(32, 94%, 93%, 0.35);
    color: #222222;
    font-size: 14px;
    display: flex;
    align-items: center;

    .left-icon {
      img {
        width: 20px;
        height: 20px;
        vertical-align: -3px;
      }
    }

    .right-title {
      display: flex;
      align-items: center;
      margin-left: 5px;
    }
  }
  .card-body {
    display: flex;
    align-items: center;
    padding: 20px 10px;
    box-sizing: border-box;

    .left-content {
      font-size: 12px;
      color: gray;
    }
    .right-content {
      font-size: 16px;
      color: #000000;
    }
  }

  .body-card {
    padding: 20px 10px;
    box-sizing: border-box;

    .num-card {
      .num {
        font-size: 18px;
        font-weight: bold;
      }
    }
    .time {
      color: rgba(0, 0, 0, 0.4);
      font-size: 12px;
      margin-top: 10px;
    }
  }
}
</style>
